import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIPS_FIND_ITINERARY_NUMBER_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/find-itinerary-number
 */
export class TripsFindItineraryNumberController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trips.FindItineraryNumber,U,80';
  public readonly path = `${BASEPATH}/trips/find-itinerary-number`;
  public readonly routeName = 'find-itinerary-number';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trips-find-itinerary-number" */ 'views/trips-find-itinerary-number-view')
  );

  public readonly pageName = 'page.Trips.FindItineraryNumber';
  public readonly clickstreamPageName = 'Trips Find Itinerary Number';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIPS_FIND_ITINERARY_NUMBER_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-find-itinerary-number-controller'
    });

    return Promise.resolve();
  }
}
